import React, { useContext } from "react";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import "../../styles/styles.css";
import StudyClippingButton from "../Tools/StudyClippingButton";
import userContext from "../../../../context/users/UserContext";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";

const StudyClippingDetails = ({ viewportIndex, handleClippingStudy, loaderRunning }) => {
const { usgAgentEnabled, reportDoneStatusState, reportingDoctorName, isWordFilePath } = useContext(studyReportContext);
const {isCreatingMaskingProfile} = useContext(ViewportContext);
 const {
    roles,
    username,
    userId
  } = useContext(userContext);

console.log("Username and reportingDoctor name", username, reportingDoctorName);

return (
  <>
    <div className="viewport-overlay-study-clipping">
      {usgAgentEnabled !== 0 && !isWordFilePath && reportDoneStatusState < 2 && reportingDoctorName !== null && reportingDoctorName == username && <span style={{ lineHeight: "15px" }}>
        <StudyClippingButton viewportIndex={viewportIndex} handleClippingStudy={handleClippingStudy} loaderRunning={loaderRunning} usgAgentEnabled={usgAgentEnabled} isCreatingMaskingProfile={isCreatingMaskingProfile} />
      </span>
      }
    </div>
  </>
  );
};

export default StudyClippingDetails;
